import { render, staticRenderFns } from "./genie-personal-information.modal.vue?vue&type=template&id=06270a9b&"
import script from "./genie-personal-information.modal.vue?vue&type=script&lang=ts&"
export * from "./genie-personal-information.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports